"use-strict";

import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";
import Photoswipe from "./photoswipe.esm.min.js";
// js gallery
class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || "no_zoom";
    this.zoomOption = this.dataset.zoomOption || "external";
    this.lightbox = null;
    this.lightboxListenersInitialized = false;
    this.drifts = [];
    this.driftViewport = null;
    this.handleResponsive = this.responsive.bind(this);
    this.init();
  }
  init() {
    if (this.type === "no_zoom") return;
    this.preventRawImageNavigation();
    window.addEventListener("resize", this.handleResponsive);
    window.addEventListener("load", this.handleResponsive, { once: true });
    this.responsive();
  }
  preventRawImageNavigation() {
    this.querySelectorAll("a.media-gallery__image").forEach((link) => {
      if (link.dataset.zoomNavigationGuard === "true") return;

      link.dataset.zoomNavigationGuard = "true";
      link.addEventListener("click", (event) => event.preventDefault());
    });
  }
  initLightBox() {
    if (this.lightboxListenersInitialized) return;
    this.lightboxListenersInitialized = true;
    this.querySelectorAll("a.media-gallery__image").forEach((a) => {
      var position = 0;
      a.addEventListener("click", (e) => {
        e.preventDefault();
        const isTouchZoomButton = e.target.closest(
          ".zoom_light_box--touch"
        );
        if (
          this.type !== "open_lightbox" &&
          window.innerWidth < 768 &&
          !isTouchZoomButton
        ) {
          return;
        }
        const target = e.currentTarget;
        const galleryItems = Array.from(
          this.querySelectorAll("a.media-gallery__image")
        );
        if (target.getAttribute("data-position")) {
          position = target.getAttribute("data-position");
        } else if (
          target
            .closest("media-gallery")
            .querySelector(".swiper-slide-active")
        ) {
          position = target
            .closest("media-gallery")
            .querySelector(".swiper-slide-active")
            .getAttribute("data-position");
        } else if (target.closest("media-gallery").firstChild) {
          position = target
            .closest("media-gallery")
            .firstChild?.getAttribute("data-position");
        }
        this.lightbox = new PhotoSwipeLightbox({
          gallery: this,
          children: "a",
          pswpModule: () => Photoswipe,
          counter: false,
          zoom: false,
          preloader: false,
          arrowPrev: false,
          arrowNext: false,
          close: false,
          loop: false,
          bgOpacity: 1
        });
        this.lightbox.on("uiRegister", () => {
          const { pswp } = this.lightbox;
          pswp?.ui.registerElement({
            name: "bls--close",
            isButton: true,
            tagName: "button",
            html: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition"><use href="#icon-close"></use></svg>',
            onClick: () => {
              pswp.close();
            },
          });
          pswp?.ui.registerElement({
            name: "thumbnails",
            className: "pswp__thumbnails",
            appendTo: "wrapper",
            onInit: (el, pswp) => {
              const thumbnailButtons = galleryItems.map((item, index) => {
                const button = document.createElement("button");
                const sourceImage = item.querySelector("img");
                const thumbnail = document.createElement("img");

                button.type = "button";
                button.className = "pswp__thumbnail-button";
                button.setAttribute("aria-label", `View image ${index + 1}`);
                button.addEventListener("click", () => pswp.goTo(index));

                thumbnail.src =
                  sourceImage?.currentSrc || sourceImage?.src || item.href;
                thumbnail.alt = "";
                thumbnail.loading = "lazy";
                button.appendChild(thumbnail);
                el.appendChild(button);
                return button;
              });

              const updateActiveThumbnail = () => {
                thumbnailButtons.forEach((button, index) => {
                  const isActive = index === pswp.currIndex;
                  button.classList.toggle("is-active", isActive);
                  if (isActive) {
                    button.setAttribute("aria-current", "true");
                  } else {
                    button.removeAttribute("aria-current");
                  }
                });

                thumbnailButtons[pswp.currIndex]?.scrollIntoView({
                  block: "nearest",
                  inline: "center",
                });
              };

              pswp.on("change", updateActiveThumbnail);
              updateActiveThumbnail();
            },
          });
          pswp?.ui.registerElement({
            name: "bottomBar",
            className: "pswp__bottom-bar",
            appendTo: "wrapper",
            onInit: (el, pswp) => {
              let next, prev, counter, useIconPrev;
              let iconNext, iconPrev, useIconNext;
              next = document.createElement("button");
              next.setAttribute("type", "button");
              next.className = "pswp__button pswp__button-next";
              // iconNext = document.createElement("svg");
              // iconNext.setAttribute("width", 6);
              // iconNext.setAttribute("height", 11);
              // iconNext.setAttribute("fill", "none");
              // useIconNext = document.createElement("use");
              // useIconNext.setAttribute("href", "#icon-next");
              // iconNext.appendChild(useIconNext);
              // next.appendChild(iconNext);
              next.innerHTML =`<svg width="6" height="11" fill="none">
              <use href="#icon-next"></use>
            </svg>`
              next.onclick = () => {
                pswp.next();
              };
              el.appendChild(next);

              counter = document.createElement("span");
              counter.className = "pswp__counter";
              pswp.on("change", () => {
                counter.innerText =
                  pswp.currIndex +
                  1 +
                  pswp.options.indexIndicatorSep +
                  pswp.getNumItems();
              });
              el.appendChild(counter);

              prev = document.createElement("button");
              prev.setAttribute("type", "button");
              prev.className = "pswp__button pswp__button-prev";
              // iconPrev = document.createElement("svg");
              // iconPrev.setAttribute("width", 6);
              // iconPrev.setAttribute("height", 11);
              // iconPrev.setAttribute("fill", "none");
              // useIconPrev = document.createElement("use");
              // useIconPrev.setAttribute("href", "#icon-back");
              // iconPrev.appendChild(useIconPrev);
              // prev.appendChild(iconPrev);
              prev.innerHTML =`<svg width="6" height="11" fill="none">
              <use href="#icon-back"></use>
            </svg>`
              prev.onclick = () => {
                pswp.prev();
              };
              el.appendChild(prev);
            },
          });
        });
        this.lightbox.init();
        this.lightbox.loadAndOpen(position - 1);
      });
    });
  }
  initDrift() {
    const viewport = window.innerWidth < 768 ? "mobile" : "desktop";
    if (this.drifts.length !== 0 && this.driftViewport === viewport) return;

    this.destroyDrift();
    this.driftViewport = viewport;
    var allTriggers = this.querySelectorAll(".drift-trigger");
    const paneContainer = this.closest(".sec__featured-product").querySelector(
      ".zoom-external-area"
    );
    if (allTriggers.length != 0) {
      allTriggers.forEach((trigger) => {
        const inlineContainer = trigger.closest("[data-pane-container]");
        const zoomImageLink = trigger.closest("a.media-gallery__image");
        trigger.dataset.zoomImage =
          zoomImageLink?.href || trigger.currentSrc || trigger.src;
        const zoomOption = this.zoomOption;
        const useFloatingTouchLens =
          viewport === "mobile" &&
          (zoomOption === "inner-1" || zoomOption === "inner-2");
        if (zoomOption === "inner-2") {
          this.drifts.push(new Drift(trigger, {
            inlinePane: true,
            zoomFactor: viewport === "mobile" ? 3 : 4,
            sourceAttribute: "data-zoom-image",
            containInline: useFloatingTouchLens,
            paneContainer: inlineContainer,
            inlineOffsetY: useFloatingTouchLens ? -130 : 0,
            namespace: useFloatingTouchLens ? "touch-zoom-circle" : null,
            hoverBoundingBox: zoomOption === "external",
            onShow: function () {
              inlineContainer.classList.add("relative");
            },
            onHide: function () {
              inlineContainer.classList.remove("relative");
            },
          }));
        } else {
          this.drifts.push(new Drift(trigger, {
            inlinePane: useFloatingTouchLens ? true : zoomOption,
            zoomFactor:
              zoomOption === "inner-1"
                ? viewport === "mobile"
                  ? 3
                  : 4
                : 5,
            sourceAttribute: "data-zoom-image",
            containInline: useFloatingTouchLens,
            paneContainer:
              zoomOption === "external" ? paneContainer : inlineContainer,
            inlineOffsetY: useFloatingTouchLens ? -130 : 0,
            namespace: useFloatingTouchLens ? "touch-zoom-square" : null,
            hoverBoundingBox: zoomOption === "external",
            onShow: function () {
              inlineContainer.classList.add("relative");
            },
            onHide: function () {
              inlineContainer.classList.remove("relative");
            },
          }));
        }
      });
    }
  }
  destroyDrift() {
    this.drifts.forEach((drift) => drift.destroy());
    this.drifts = [];
    this.driftViewport = null;
  }
  responsive() {
    if (window.innerWidth >= 768) {
      if (this.type === "open_lightbox") {
        this.initLightBox();
      } else {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        if (
          this.type === "inner_zoom_circle" ||
          this.type === "inner_zoom_square"
        ) {
          this.initLightBox();
        }
        this.initDrift();
      }
    } else {
      const useTouchZoom =
        this.type === "inner_zoom_circle" ||
        this.type === "inner_zoom_square";

      if (useTouchZoom) {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        this.initLightBox();
        this.initDrift();
      } else if (this.type !== "open_lightbox") {
        this.destroyDrift();
        this.initLightBox();
      } else {
        this.initLightBox();
      }
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper !== "undefined") {
      const thumbnailSlide = this.querySelector('.thumbnail-slide');
      if (thumbnailSlide?.swiper) {
        thumbnailSlide.swiper.update();
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResponsive);
    window.removeEventListener("load", this.handleResponsive);
    this.destroyDrift();
  }
}
customElements.define("zoom-action", ZoomAction);
